import { FC } from 'react';

export interface ILogo {
  size?: 'tyny' | 'small' | 'medium' | 'large'
}

const Logo: FC<ILogo> = ({ size = 'medium' }) => (
  <div className={`
    ${{
      'tyny': '',
      'small': '',
      'medium': '[&>svg]:h-[35px]',
      'large': '',
    }[size]}
  `}>
    <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_722)">        
        <path d="M48.4925 0H8.89193C3.98105 0 0 3.93294 0 8.78448V48.2155C0 53.0671 3.98105 57 8.89193 57H48.4925C53.4033 57 57.3844 53.0671 57.3844 48.2155V8.78448C57.3844 3.93294 53.4033 0 48.4925 0Z" fill="#EC6813"/>
        <path d="M13.547 20.1893V20.4446C13.547 23.9651 15.8253 26.2494 18.9842 26.2494C21.1876 26.2494 22.9524 25.0871 24.3091 22.7289L26.4412 24.1431C24.7886 27.0825 22.2179 28.5706 18.838 28.5706C13.8428 28.5706 10.4629 25.0132 10.4629 19.7156C10.4629 14.4181 13.8802 11.042 18.6543 11.042C23.4284 11.042 26.55 14.2702 26.55 19.6417V20.1859H13.547V20.1893ZM18.5421 13.4775C15.8593 13.4775 13.8394 15.184 13.547 17.9419H23.5373C23.3536 15.0765 21.5174 13.4775 18.5421 13.4775Z" fill="white"/>
        <path d="M30.7732 11.66H33.4561V14.7069C34.7414 12.3487 36.9074 11.0789 39.4441 11.0789C44.1468 11.0789 47.3057 14.4885 47.3057 19.823C47.3057 25.1575 44.1468 28.5672 39.5563 28.5672C36.8394 28.5672 34.8196 27.3343 33.5683 24.9392V35.7896H30.7766V11.66H30.7732ZM39.0361 25.8495C42.3038 25.8495 44.3236 23.7466 44.3236 20.1522C44.3236 16.0875 42.2664 13.7663 38.9987 13.7663C35.7309 13.7663 33.4901 15.98 33.4901 19.8264C33.4901 23.6727 35.7309 25.8495 39.0361 25.8495Z" fill="white"/>
        <path d="M43.5347 35.8534C44.4052 35.8467 45.5681 35.9408 45.5681 35.9408C46.0305 48.1215 31.4294 55.0819 22.8469 45.7397L25.285 43.5529C32.3101 50.3654 42.535 45.3366 42.1167 35.8198C42.1167 35.8198 43.1606 35.8366 43.5313 35.8534H43.5347Z" fill="white"/> 
      </g>
      <defs>
      <clipPath id="clip0_1_722">
      <rect width="230" height="57" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  </div>
);

export default Logo;
